import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { Paper, Typography, FormControlLabel, Checkbox } from '@mui/material';
import { Grid } from '@mui/material';
import NavigationButtons from '../container/NavigationButtons';
// import dateFormat from 'dateformat'
import MDTextField from './custom/MDTextField';
import Person from './custom/Person';
import Address from './custom/Address';

function MailShipCT(props) {
  const dispatch = useDispatch()
  const activeStep = useSelector((state) => state.activeStep)
  // const mailship = useSelector((state) => state.mailship)
  // const ship = useSelector((state) => state.ship)
  // const carrier = useSelector((state) => state.carrier)
  const person = useSelector((state) => state.person)
  // const addresses = useSelector((state) => state.addresses)
  const initialMailship = useSelector((state) => state.mailship)
  const initialShip = useSelector((state) => state.ship)
  const initialCarrier = useSelector((state) => state.carrier)
  const initialAddresses = useSelector((state) => state.addresses)

  const [mailship, setMailShip] = useState(initialMailship);
  const [ship, setShip] = useState(initialShip);
  const [carrier, setCarrier] = useState(initialCarrier);
  const [addresses, setAddresses] = useState(initialAddresses)

  const [value, setValue] = useState(mailship.sendOrReceive === -1? 0 : mailship.sendOrReceive);
  const [summary, setSummary] = useState(false);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [business, setBusiness] = useState(false);
  const [businessship, setBusinessShip] = useState(false);
  const [businesscarrier, setBusinessCarrier] = useState(carrier.business !== ''? true : false);

  const [requiredFields, setRequiredFields] = useState({shipDate: false, carrier: false, mailship: false, ship: false, address3: false, address4: false, mailshiplocator:''});

    useEffect(() => {
      setBusinessCarrier(carrier.business !== ''? true : false)
      setRequiredFields({...requiredFields, carrier: true})
    }, [carrier])

    useEffect(() => {
      setMailShip(initialMailship)
    }, [initialMailship])
    useEffect(() => {
      setShip(initialShip)
    }, [initialShip])
    useEffect(() => {
      setCarrier(initialCarrier)
    }, [initialCarrier])
    useEffect(() => {
      setAddresses(initialAddresses)
    }, [initialAddresses])
  
  // constructor(props) {
  //   super(props);
  //   this.state = {activeStep: props.activeStep, mailship: props.mailship, ship: props.ship, carrier: props.carrier, businessship: false, businesscarrier: false,
  //                   updatePerson: props.updatePerson, person: props.person, addresses: props.addresses,
  //                   summary: false, error: false, errorText: '', business: false,          
  //                   requiredFields: {shipDate: false, carrier: false, mailship: false, ship: false, address3: false, address4: false, mailshiplocator:''}};
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (this.props !== nextProps) {
  //     const { mailship, ship, carrier, addresses, person } = this.state
  //     // console.log(JSON.stringify(mailship) + ' mailshipchange ' + JSON.stringify(nextProps.mailship))
  //     if (nextProps.mailship !== mailship) {
  //       this.setState({ mailship: nextProps.mailship });
  //     }
  //     if (nextProps.ship !== ship) {
  //       this.setState({ ship: nextProps.ship });
  //     }
  //     if (nextProps.carrier !== carrier) {
  //       this.setState({ carrier: nextProps.carrier });
  //     }
  //     if (nextProps.addresses !== addresses) {
  //       this.setState({ addresses: nextProps.addresses });
  //     }
  //     // For currency transporter workflow, the person/business information is duplicated
  //     // to that of the carrier information
  //     if (nextProps.person !== person) {
  //       this.setState({ carrier: nextProps.person, businesscarrier: nextProps.person.business !== ''? true : false})
  //     }
  //   }
  // }

  const handleChange = (propertyName, value) => {  
    const newMailShip = {
      ...mailship,
      sendOrReceive: 2,
      [propertyName]: value,
    };
    setMailShip(newMailShip)
    // dispatch( updateMailShip(newMailShip) )
  }

  const updatePerson = (person) => {
    // console.log(JSON.stringify(mailship) + ' mailship ' + JSON.stringify(person))
    setMailShip(person)
    // dispatch( updateMailShip(person) )
  } 

  const updatePersonShip = (person) => {
    // console.log(JSON.stringify(mailship) + ' mailship ' + JSON.stringify(person))
    setShip(person)
    // dispatch( updateShip(person) )
  }

  const updatePersonCarrier = (person) => {
    // console.log(JSON.stringify(mailship) + ' mailship ' + JSON.stringify(person))
    setCarrier(person)
    // dispatch( updateCarrier(person) )
  } 

  const updateAddresses = (address, index) =>  {
    const newAddresses = {...addresses}

    newAddresses[index] = address      
    setAddresses(newAddresses)
    // dispatch( updateAddress(newAddresses) )   
  }

  const handleError = (propertyName, error) => {    

      if (propertyName === 'shipDate') {
        error = !error
      } else  if (propertyName === 'person') {
        propertyName = 'mailship'
      }

      let newRequiredFields = {
        ...requiredFields,
        [propertyName]: error,      
      };

      // console.log('shprcv err ' + JSON.stringify(newRequiredFields))
      setRequiredFields(newRequiredFields)    
  }

  const handleChangeChecked = (type) => event => {
    // console.log('ship buss ' + type + ' ' + event.target.checked)
    if (type === 'C') {
      setBusinessCarrier(event.target.checked)
    } else
    if (type === 'M') {
      setBusiness(event.target.checked)
    } else {
      setBusinessShip(event.target.checked)
    }
  }

  
  return (
    <div>
      <Paper sx={{
        p: 4,
        mb: 1.5,
        textAlign: 'left',
        justifyContent: 'center',
        color: 'text.primary',
        backgroundColor: '#ffffff',
        borderRadius: 3,
      }}>
            <Grid>
                  <Grid container columnSpacing="12px" sx={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }}>
                    <MDTextField name='shipDate'  mailshiplocator='mailship' label='Date Shipped' value={mailship.shipDate} type='date' inputLabelProps={{ shrink: true }} handleChange={handleChange} 
                        handleError={handleError} required={true} summary={summary} />                  
                    <MDTextField name='methodOfShipment' label='Method of Shipment' mailshiplocator='mailship' value={mailship.methodOfShipment} handleChange={handleChange} 
                        handleError={handleError} required={false} inputProps={{ maxLength: 15, }} summary={summary} />
                  </Grid>  
                  
                  <Typography sx={{
                    fontSize: '1.125rem',
                    color: 'text.primary',
                    pt: 2,
                    mb: 0,
                    fontWeight: "700"
                  }}>Carrier Information</Typography>
                  <FormControlLabel
                    sx={{ ml: 1 }}
                    control={
                    <Checkbox
                      checked={businesscarrier ? true: false}
                      onChange={handleChangeChecked('C')}
                      value={businesscarrier}
                    /> }
                    label="Business"
                  />
                    <Person person={carrier} mailshiplocator='carrier' updatePerson={updatePersonCarrier} handleError={handleError} 
                            shiprecv={true} business={businesscarrier} inputLabelProps={{ shrink: true }} />
</Grid></Paper>

<Paper sx={{
        p: 4,
        mb: 1.5,
        textAlign: 'left',
        justifyContent: 'center',
        color: 'text.primary',
        backgroundColor: '#ffffff',
        borderRadius: 3,
      }}>
<Grid>
                  <Typography sx={{
                    fontSize: '1.125rem',
                    color: 'text.primary',
                    pt: 2,
                    mb: 0,
                    fontWeight: "700"
                  }}>Receiver Information</Typography>
                  <FormControlLabel
                    sx={{ ml: 1 }}
                    control={
                    <Checkbox
                      checked={business ? true: false}
                      onChange={handleChangeChecked('M')}
                      value={business}
                    /> }
                    label="Business"
                  />
                    <Person person={mailship} mailshiplocator='mailship' updatePerson={updatePerson} handleError={handleError} 
                            shiprecv={true} business={business} inputLabelProps={{ shrink: true }} />
                    <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    
                    </Grid>
                    <Grid>
                    <Typography sx={{
                      mr: 2,
                      fontSize: '0.9375rem',
                      color: 'text.primary',
                      pt: '22px',
                      mb: 0,
                      fontWeight: "660"
                    }}>Receiver's Address</Typography>
                  </Grid>
                    <Address address={addresses[4]} index='4' updateAddress={updateAddresses}  handleError={handleError} /> 
</Grid></Paper>

<Paper sx={{
        p: 4,
        mb: 1.5,
        textAlign: 'left',
        justifyContent: 'center',
        color: 'text.primary',
        backgroundColor: '#ffffff',
        borderRadius: 3,
      }}>
<Grid>
                  <Typography sx={{
                    fontSize: '1.125rem',
                    color: 'text.primary',
                    pt: 2,
                    mb: 0,
                    fontWeight: "700"
                  }}>Shipper Information</Typography>
                  <FormControlLabel
                    sx={{ ml: 1 }}
                    control={
                    <Checkbox
                      checked={businessship ? true: false}
                      onChange={handleChangeChecked('S')}
                      value={businessship}
                    /> }
                    label="Business"
                  />
                    <Person person={ship} mailshiplocator='ship' updatePerson={updatePersonShip} handleError={handleError} shiprecv={true} business={businessship} inputLabelProps={{ shrink: true }} />
                    <Grid container sx={{ flexDirection: 'row', alignItems: 'center' }}>
                    
                    </Grid>
                    <Grid>
                    <Typography sx={{
                      mr: 2,
                      fontSize: '0.9375rem',
                      color: 'text.primary',
                      pt: '22px',
                      mb: 0,
                      fontWeight: "660"
                    }}>Shipper's Address</Typography>
                  </Grid>
                    <Address address={addresses[3]} index='3' updateAddress={updateAddresses}  handleError={handleError} /> 

                {/* </TabContainer>                
            </AppBar>                   */}
          </Grid>        

            <NavigationButtons mailship={mailship} mailshipPerson={person} addresses={addresses} carrier={carrier} ship={ship}
                  allReqDone={requiredFields.address3 && requiredFields.address4 && !error && 
                              requiredFields.shipDate && requiredFields.carrier && requiredFields.mailship && requiredFields.ship
          } />
          </Paper>   
      </div>
  );
}

export default MailShipCT;